import { Task } from "@medplum/fhirtypes";

import { z } from "zod";

import { ChecklistTaskStatus } from "@/constants/checklist";

export const ChecklistTodosForm = z.object({
  selectedTasks: z.array(z.string()).optional(),
});

export type ChecklistTodosFormType = z.infer<typeof ChecklistTodosForm>;

export const checklistTodosFormInitialValues = (tasks: Task[]) => {
  return tasks
    .filter((task) => task.status === ChecklistTaskStatus.Completed)
    .map((task) => task.id!);
};
